import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchError } from './commonSlice';

const initialState = {
  list: [],
  perPage: '',
  total: '',
  loading: false,
  errorMessage: '',
};

export const getRoleList = createAsyncThunk('get-role-list', async ({ data }, { dispatch }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}client/role/list`, { params: data });
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const deleteRole = createAsyncThunk('delete-role', async (id, { dispatch }) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}client/role/${id}`);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const roleCreate = createAsyncThunk('role-create', async ({ data }, { dispatch }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}client/role`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const roleUpdate = createAsyncThunk('role-update', async ({ id, data }, { dispatch }) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}client/role/${id}`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error.data?.responseMessage));
    return error.data?.responseMessage;
  }
});

export const getPermissionList = createAsyncThunk('get-permission', async (data, { dispatch }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}client/permission/list`, { params: data });
    return response;
  } catch (error) {
    dispatch(fetchError(error));
    return error;
  }
});

export const getAllowedPermissions = createAsyncThunk('edit-permission', async (id, { dispatch }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}client/permission/assigned-permission/${id}`);
    return response;
  } catch (error) {
    dispatch(fetchError(error));
    return error;
  }
});

export const updatePermissions = createAsyncThunk('update-permission', async (data, { dispatch }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}client/permission/assigned-permission`, data);
    return response;
  } catch (error) {
    dispatch(fetchError(error));
    return error;
  }
});

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRoleList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoleList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.roleList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
        state.errorMessage = '';
      })
      .addCase(getRoleList.rejected, (state, action) => {
        state.loading = false;
        state.list = '';
        state.perPage = '';
        state.total = '';
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(roleUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(roleUpdate.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(roleUpdate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(roleCreate.pending, (state) => {
        state.loading = true;
      })
      .addCase(roleCreate.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(roleCreate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });

    builder
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRole.fulfilled, (state) => {
        state.loading = false;
        state.errorMessage = '';
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error?.message;
      });
  },
});

export default roleSlice.reducer;
